module.exports = __webpack_public_path__ + "img/file-earmark-excel.50f1a69f.svg";